import React, { useState } from 'react';
import HookForm from '../../../../components/HookForm/HookForm';

const CarBuyerForm = ({ onBuyerCreated, carData, currentData }) => {
  const [buyerForm, setBuyerForm] = useState([
    {
      name: 'JuridicalName',
      label: 'Наименование юр. лица',
      placeholder: 'ТОО',
      rules: { required: true },
      defaultValue: currentData?.JuridicalName,
      capitalize: true,
    },
    {
      name: 'JuridicalDirectorName',
      label: 'ФИО директора',
      placeholder: '',
      rules: { required: true },
      defaultValue: currentData?.JuridicalDirectorName,
      capitalize: true,
    },
    {
      name: 'CompanyDetails',
      label: 'Реквизиты компании',
      placeholder: 'БИН 123456789, г. Алматы, ул. Примерная, 1',
      rules: { required: true },
      defaultValue: currentData?.CompanyDetails,
    },
    {
      name: 'ContractNumber',
      label: 'Номер договора',
      placeholder: '123/2024',
      rules: { required: true },
      defaultValue: currentData?.ContractNumber,
    },
    {
      name: 'RepairWorkList',
      label: 'Список работ',
      placeholder: 'Замена масла, шиномонтаж',
      rules: { required: true },
      defaultValue: currentData?.RepairWorkList,
    },
  ]);

  const handleBuyerSubmit = (values) => {
    if (onBuyerCreated) {
      onBuyerCreated(values);
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <HookForm
        inputs={buyerForm}
        title={'Данные покупателя (юр. лицо)'}
        grid={{ display: 'grid', gap: '20px', gridTemplateColumns: '1fr 1fr' }}
        handlerSetState={setBuyerForm}
        onSubmit={handleBuyerSubmit}
        action={'Далее'}
        border
      />
    </div>
  );
};

export default CarBuyerForm; 